export class Csp5030Class {
    collection_id: number;
    UserNam: string;
    CompanyName: string;
}
